import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export enum SearchIconVariant {
  SEARCH1 = 'search1',
  SEARCH2 = 'search2',
  SMALL = 'small',
}

export interface ISearchIConProps extends IConDefaultType {
  variant?: SearchIconVariant;
  backgroundColor?: string;
}

function SearchIcon({
  color,
  className,
  size = 20,
  rotate,
  flip,
  variant = SearchIconVariant.SEARCH1,
  backgroundColor = 'white',
}: ISearchIConProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SearchIconVariant.SEARCH1 && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            transform="translate(3 3)"
            d="M8.09961 0C12.573 0 16.2 3.62628 16.2002 8.09961C16.2002 10.0119 15.536 11.7687 14.4277 13.1543L17.7363 16.4639C18.0878 16.8153 18.0878 17.3849 17.7363 17.7363C17.3849 18.0878 16.8153 18.0878 16.4639 17.7363L13.1543 14.4277C11.7687 15.536 10.0119 16.2002 8.09961 16.2002C3.62628 16.2 0 12.573 0 8.09961C0.000227793 3.62642 3.62642 0.000227796 8.09961 0ZM8.09961 1.7998C4.62053 1.80003 1.80003 4.62053 1.7998 8.09961C1.7998 11.5789 4.62039 14.4002 8.09961 14.4004C9.80056 14.4004 11.3431 13.7245 12.4766 12.6289C12.4985 12.601 12.5231 12.5746 12.5488 12.5488C12.5746 12.5231 12.601 12.4985 12.6289 12.4766C13.7245 11.3431 14.4004 9.80056 14.4004 8.09961C14.4002 4.62039 11.5789 1.7998 8.09961 1.7998Z"
            fill={color || theme.color.icon.icon_3}
          />
        </svg>
      )}
      {variant === SearchIconVariant.SEARCH2 && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.2929 16.2929C16.6834 15.9024 17.3166 15.9024 17.7071 16.2929L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.2929 17.7071C15.9024 17.3166 15.9024 16.6834 16.2929 16.2929Z"
            fill={color || EColorMap.gray_0}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
      {variant === SearchIconVariant.SMALL && (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" fill={backgroundColor} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.33333 11.1706C5.33333 7.94629 7.95197 5.33053 11.1847 5.33053C14.4174 5.33053 17.036 7.94629 17.036 11.1706C17.036 14.3948 14.4174 17.0106 11.1847 17.0106C7.95197 17.0106 5.33333 14.3948 5.33333 11.1706ZM11.1847 3.99719C7.21777 3.99719 4 7.20773 4 11.1706C4 15.1334 7.21777 18.3439 11.1847 18.3439C12.9214 18.3439 14.5145 17.7286 15.7568 16.7042L18.8607 19.8026C19.1213 20.0627 19.5434 20.0624 19.8035 19.8018C20.0636 19.5412 20.0632 19.1191 19.8027 18.859L16.7029 15.7646C17.7432 14.5203 18.3693 12.9186 18.3693 11.1706C18.3693 7.20773 15.1516 3.99719 11.1847 3.99719Z"
            fill={color || EColorMap.gray_0}
          />
        </svg>
      )}
    </i>
  );
}

export default SearchIcon;
